import { render } from "./AffirmPlaceOrder.vue?vue&type=template&id=77ebeaae&scoped=true"
import script from "./AffirmPlaceOrder.vue?vue&type=script&lang=js"
export * from "./AffirmPlaceOrder.vue?vue&type=script&lang=js"

import "./AffirmPlaceOrder.vue?vue&type=style&index=0&id=77ebeaae&lang=scss&scoped=true"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ebeaae"]])

export default __exports__